module.exports = __WEBPACK_EXTERNAL_MODULE_19__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}
// module id = 19
// module chunks = 0